import { inject } from '@angular/core';
import { Router, type CanActivateChildFn, type UrlTree } from '@angular/router';
import { AuthenticationService } from '@app/core/auth';
import { SessionManager } from '@app/core/session/session-manager.service';
import { EnvironmentService } from '@core/services/environment.service';
import { Role } from '@core/types/role.interface';

const redirectToLogin = (router: Router, returnUrl: string): UrlTree => {
  return router.createUrlTree(['/auth/login'], { queryParams: { returnUrl } });
};

export const authGuard: CanActivateChildFn = (route, state) => {
  const router = inject(Router);
  const authService = inject(AuthenticationService);
  const sessionManager = inject(SessionManager);
  const environmentService = inject(EnvironmentService);

  if (!authService.isLoggedIn()) {
    return redirectToLogin(router, state.url);
  }

  const requiredRoles = route.data['roles'] as Role[];
  if (requiredRoles && !environmentService.isProduction) {
    const userRole = authService.currentUser()!.user.role;
    if (!requiredRoles.includes(userRole)) {
      return router.createUrlTree(['/unauthorized']);
    }
  }

  sessionManager.refreshSession(7);
  return true;
};
